import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { ActiveCommentCommand } from './active-comment-command';
import {
  InsertCommentCommand,
  CommentIdAttibute,
  CommentTypeAttibute,
  CommentActiveAttibute,
} from './insert-comment-command';
import { RemoveCommentCommand } from './remove-comment-command';

export class CommentEditing extends Plugin {
  static get pluginName(): string {
    return 'CommentEditing';
  }

  init(): void {
    // Allow comment attribute on text nodes.
    const { editor } = this;

    editor.model.schema.extend('$text', {
      allowAttributes: [
        CommentIdAttibute,
        CommentTypeAttibute,
        CommentActiveAttibute,
      ],
    });
    editor.conversion.attributeToAttribute({
      model: CommentIdAttibute,
      view: `data-${CommentIdAttibute}`,
    });
    editor.conversion.attributeToAttribute({
      model: CommentTypeAttibute,
      view: `data-${CommentTypeAttibute}`,
    });
    // TODO: Check whether we need downcast
    editor.conversion.attributeToAttribute({
      model: CommentActiveAttibute,
      view: `data-${CommentActiveAttibute}`,
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: CommentIdAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${CommentIdAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: CommentTypeAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${CommentTypeAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });
    editor.conversion.for('downcast').attributeToElement({
      model: {
        key: CommentActiveAttibute,
        name: '$text',
      },
      view: (value, { writer }) => {
        const attributeEl = {};

        attributeEl[`data-${CommentActiveAttibute}`] = value;

        return writer.createAttributeElement('span', attributeEl);
      },
      converterPriority: 'high',
    });

    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${CommentIdAttibute}`,
      },
      model: {
        key: CommentIdAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(`data-${CommentIdAttibute}`);

          return value;
        },
      },
    });
    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${CommentTypeAttibute}`,
      },
      model: {
        key: CommentTypeAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(`data-${CommentTypeAttibute}`);

          return value;
        },
      },
    });
    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        attributes: `data-${CommentActiveAttibute}`,
      },
      model: {
        key: CommentActiveAttibute,
        value: (viewElement) => {
          const value = viewElement.getAttribute(
            `data-${CommentActiveAttibute}`,
          );

          return value;
        },
      },
    });

    editor.commands.add(
      'insertCommentCommand',
      new InsertCommentCommand(this.editor),
    );
    editor.commands.add(
      'removeCommentCommand',
      new RemoveCommentCommand(this.editor),
    );
    editor.commands.add(
      'activeCommentCommand',
      new ActiveCommentCommand(this.editor),
    );
  }
}
